import { takeLatest, call, put } from "redux-saga/effects";
import {
  regionUpdated,
  REGION_UPDATE_REQUEST,
  regionUpdateError,
} from "../../actions/regions";
import updateRegion from "../../../../../backend/oncall/partners/regions/update";

const requestUpdate = function*(action) {
  try {
    yield call(
      updateRegion,
      action.payload.regionId,
      action.payload.formData.name,
      action.payload.formData.administrative,
      action.payload.formData.defaultShiftChangeTime,
      action.payload.formData.enabled,
      action.payload.formData.timeZone,
      parseInt(action.payload.formData.defaultShiftDays, 10),
    );
    yield put(regionUpdated());
  } catch (error) {
    yield put(regionUpdateError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(REGION_UPDATE_REQUEST, requestUpdate);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/regions/request-update.js